document.addEventListener('DOMContentLoaded', function () {
    document.getElementById("forhandler-form").addEventListener("submit", opretForhandler);
});

function opretForhandler(e) {
    e.preventDefault();

    const adresse = document.getElementById("adresse").value;
    const latitudeField = document.getElementById("latitude");
    const longitudeField = document.getElementById("longitude");

    if (adresse) {
        // Brug Nominatim API til at hente koordinater baseret på adressen
        fetch(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(adresse)}&format=json&addressdetails=1`, {
            headers: {
                'User-Agent': 'Bilmedie/1.0'  // Erstat med navnet på din webshop
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error("Nominatim API returfejl: " + response.statusText);
            }
            return response.json();
        })
        .then(data => {
            if (data.length > 0) {
                const location = data[0];
                const latitude = location.lat;
                const longitude = location.lon;

                latitudeField.value = latitude;
                longitudeField.value = longitude;

                // Send forhandlerdata til serveren eller gem i metafields
                const forhandlerData = {
                    navn: document.getElementById("navn").value,
                    adresse: adresse,
                    latitude: latitude,
                    longitude: longitude
                };

                fetch('/admin/api/2023-01/metafields.json', {
                    method: 'POST',
                    body: JSON.stringify(forhandlerData),
                    headers: { 'Content-Type': 'application/json' },
                })
                .then(response => response.json())
                .then(() => {
                    hentForhandlere();
                    document.getElementById("forhandler-form").reset();
                })
                .catch(error => console.error("Fejl ved oprettelse af forhandler:", error));
            } else {
                alert("Kunne ikke finde koordinater for den indtastede adresse.");
            }
        })
        .catch(error => {
            console.error("Fejl ved anmodning til Nominatim:", error);
            alert("Der opstod en fejl ved at hente koordinater.");
        });
    } else {
        alert("Indtast en adresse for at fortsætte.");
    }
}

function hentForhandlere() {
    // Hent forhandlere fra din backend eller metafields
    fetch('/admin/api/2023-01/metafields.json')
        .then(response => response.json())
        .then(data => {
            const forhandlerList = document.getElementById("forhandler-list");
            forhandlerList.innerHTML = "";
            data.forEach(forhandler => {
                const item = document.createElement("div");
                item.innerHTML = `
                    <strong>${forhandler.navn}</strong><br>
                    ${forhandler.adresse}<br>
                    <button onclick="redigerForhandler('${forhandler.id}')">Rediger</button>
                    <button onclick="sletForhandler('${forhandler.id}')">Slet</button>
                `;
                forhandlerList.appendChild(item);
            });
        })
        .catch(error => console.error("Fejl ved hentning af forhandlere:", error));
}

function redigerForhandler(id) {
    // Rediger eksisterende forhandler
}

function sletForhandler(id) {
    fetch(`/admin/api/2023-01/metafields/${id}.json`, { method: 'DELETE' })
        .then(() => hentForhandlere())
        .catch(error => console.error("Fejl ved sletning af forhandler:", error));
}
